
import axios from '@/utils/axios'

// 草稿箱列表
export const getDraftList = function (data: any) {
    return axios.post('/draft/getDraftList', data)
}

// 草稿箱详情
export const getDraftById = function (id: any) {
    return axios.get('/draft/getDraftById', { params: { id: id } })
}

// 编辑保存/提交草稿
export const setDraftById = function (data: any) {
    return axios.post('/draft/setDraftById', data)
}

// 删除草稿
export const delDraftById = function (data: { id: number }) {
    return axios.delete('/draft/delDraftById', {data})
}
